const PageRoute = {
  dashboard: '/dashboard',
  account: {
    viewBalance: '/account/view-balance',
    payment: {
      recurringPayment: '/account/recurring-payment',
      rescurringPaymentSucess: '/account/recurring-payment/success',
    }
  },
  products: {
    subscriptions: {
      index: '/subscriptions',
      pendingActions: '/subscriptions/pending-actions',
    }
  }
};

export default PageRoute;